<po-widget class="po-lg-12 po-mb-1 po-mt-2">
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <span class="po-font-text-large-bold">Código</span>
        <po-input #inputBarcode [(ngModel)]="barcodeValue"
        p-icon="an an-barcode" name="inputBarcode"
        (p-change)="searchCode()"
        (click)="onInputClick()"
        p-auto-focus="true" p-clean="true" p-emit-all-changes="true"
        inputmode="none"
        (p-enter)="disableKeyboard()"
        (keyup.enter)="searchCode()"
        (keyup.tab)="searchCode()"
        >
      </po-input>
    </div>
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" *ngIf="itemPackOrigin">
      <span class="po-font-text-large-bold">Quantidade</span>
      <po-input [ngModel]="quantityValue" p-icon="an an-list-numbers" name="input" p-disabled="true"></po-input>
    </div>
    <po-button *ngIf="!activedScanner" p-kind="primary" (p-click)="startScan()" p-icon="an an-camera"
      p-label="Ler Cód. Barras" class="po-xl-6 po-lg-6 po-md-6 po-sm-12 po-text-center"></po-button>
    <po-button *ngIf="barcodeValue !== ''" p-kind="primary" (p-click)="searchCode()" p-icon="an an-keyboard"
      p-label="Ler Código Digitado" class="po-xl-6 po-lg-6 po-md-6 po-sm-12 po-text-center po-mt-sm-1"></po-button>
    <po-button *ngIf="activedScanner" p-kind="primary" (p-click)="stopScan()" p-icon="an an-camera"
      p-label="Encerrar Leitura" class="po-mt-1 po-xl-6 po-lg-6 po-md-6 po-sm-12 po-text-center"></po-button>
    <div class="scanner-container po-mt-2 po-text-center" *ngIf="activedScanner">
      <zxing-scanner [formats]="formatsEnabled" [autostart]="true" [tryHarder]="true"
        (scanSuccess)="onCodeResult($event)">
      </zxing-scanner>
      <div class="scanner-overlay" *ngIf="!scannedEffect">
        <p>Posicione o código dentro da câmera...</p>
      </div>
      <div class="scanner-border" *ngIf="activedScanner"
        [ngClass]="{ 'border-green': scannedEffect, 'border-red': !scannedEffect }"></div>
    </div>
  </div>
</po-widget>